module.exports = __webpack_public_path__ + "lazer3.png?4da8d9a443ab5686d6287c577fe76dc3";